import PropTypes from "prop-types";
import cn from "classnames";
import styles from "solar/components/TextArea.module.scss";
import TextAreaAutoSize from "react-textarea-autosize";

export default function TextArea(props) {
  const {
    name,
    register,
    form,
    disabled,
    readOnly,
    required,
    pattern,
    maxLength,
    hasError,
    placeholder,
    rows,
    cols,
    minRows,
    onClick,
    onFocus,
    onBlur,
    onKeyDown,
    onKeyUp,
    onKeyPress,
    block,
    className,
    onChange,
    value,
  } = props;

  // if hooks-form is being used, pass register object, otherwise pass native onChange
  let formEventProps = {};
  if (register) {
    formEventProps = {
      ...register(name, {
        onBlur,
        onChange,
      }),
    };
  } else {
    formEventProps.onChange = onChange;
  }

  return (
    <TextAreaAutoSize
      id={name}
      name={name}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...formEventProps}
      form={form}
      pattern={pattern}
      placeholder={placeholder}
      required={required}
      readOnly={readOnly}
      maxLength={maxLength}
      rows={rows}
      cols={cols}
      minRows={minRows}
      onClick={onClick}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      onKeyPress={onKeyPress}
      value={value}
      className={cn(
        styles.component,
        hasError && styles.error,
        disabled && styles.disabled,
        block && styles.block,
        className
      )}
    />
  );
}

TextArea.propTypes = {
  name: PropTypes.string.isRequired,
  register: PropTypes.func,
  form: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  pattern: PropTypes.func,
  maxLength: PropTypes.number,
  hasError: PropTypes.bool,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  cols: PropTypes.number,
  minRows: PropTypes.number,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onKeyPress: PropTypes.func,
  onChange: PropTypes.func,
  block: PropTypes.bool,
  className: PropTypes.node,
  value: PropTypes.string,
};

TextArea.defaultProps = {
  form: "",
  disabled: false,
  readOnly: false,
  required: false,
  pattern: null,
  maxLength: 524288,
  hasError: false,
  placeholder: "",
  rows: 2,
  cols: 20,
  minRows: 1,
  onClick: null,
  onFocus: null,
  onBlur: null,
  onKeyDown: null,
  onKeyUp: null,
  onKeyPress: null,
  onChange: undefined,
  block: false,
  className: null,
  value: undefined,
};
